export type BodyConsolidatedEntriesVehicular =
  | {
      Tipo_consulta_BD: 'RANGO_MESES';
      mes_inicial: string;
      mes_final: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'RANGO_DIAS';
      fecha_inicial: string;
      fecha_final: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ACTUAL';
      anio_actual: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ANTERIOR';
      anio_anterior: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'MES_ACTUAL';
      mes_actual: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'MES_ANTERIOR';
      mes_anterior: string;
      sucursal: string;
    };

export interface ResponseConsolidatedEntriesVehicular {
  fechas:    DateConsolidatedEntriesVehicular[];
  resumen:   SummaryConsolidatedEntriesVehicular[];
  anio_base: string;
}

export interface DateConsolidatedEntriesVehicular {
  periodo_fecha:     string;
  entradas_motos:    number;
  entradas_carros:   number;
  total_consolidado: number;
}

export interface SummaryConsolidatedEntriesVehicular {
  total_motos:       number;
  total_carros:      number;
  promedio_motos:    number;
  promedio_carros:   number;
  total_vehiculos:   number;
  total_consolidado: number;
}
